import i18n from '@dms/i18n';
import {settingsRoutes} from '@dms/routes';
import {SettingsTemplate} from '@dms/settings/shared';

import {BusinessCaseSeriesDefinitionList} from './components/BusinessCaseSeriesDefinitionList';

export function BusinessCaseDefinition() {
  return (
    <SettingsTemplate
      header={{
        title: i18n.t('page.salesSettingsBusinessCase.labels.businessCaseDefinition'),
        breadcrumbs: [
          {
            label: i18n.t('page.businessCases.title'),
            href: settingsRoutes.businessCase,
          },
        ],
      }}
      data-testid="settings-businessCases-definition"
      description={i18n.t('page.salesSettings.labels.businessCaseDefinitionDescription')}
    >
      <BusinessCaseSeriesDefinitionList />
    </SettingsTemplate>
  );
}
